var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpCenterWorkflowsTasks({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82407 1.75H2.00926C1.86607 1.75 1.75 1.86607 1.75 2.00926V3.82407C1.75 3.96726 1.86607 4.08333 2.00926 4.08333H3.82407C3.96726 4.08333 4.08333 3.96726 4.08333 3.82407V2.00926C4.08333 1.86607 3.96726 1.75 3.82407 1.75Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9908 9.91675H10.176C10.0328 9.91675 9.91675 10.0328 9.91675 10.176V11.9908C9.91675 12.134 10.0328 12.2501 10.176 12.2501H11.9908C12.134 12.2501 12.2501 12.134 12.2501 11.9908V10.176C12.2501 10.0328 12.134 9.91675 11.9908 9.91675Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 11.0833H4.08325C3.43892 11.0833 2.91658 10.5609 2.91658 9.91659V9.33325V7.58325C2.91658 7.26109 3.17775 6.99992 3.49992 6.99992H10.4999C10.8221 6.99992 11.0833 6.73875 11.0833 6.41658V3.49992C11.0833 3.17775 10.8221 2.91658 10.4999 2.91658H4.66658",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpCenterWorkflowsTasks);
export default __webpack_public_path__ + "static/media/help-center-workflows-tasks.16f8c3879d9bc44b3fbba87f7773780b.svg";
export { ForwardRef as ReactComponent };